import { render, staticRenderFns } from "./PhysicianCreateModal.vue?vue&type=template&id=70f3043c"
import script from "./PhysicianCreateModal.vue?vue&type=script&lang=js"
export * from "./PhysicianCreateModal.vue?vue&type=script&lang=js"
import style0 from "./PhysicianCreateModal.vue?vue&type=style&index=0&id=70f3043c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports